import React, { useContext, Fragment } from 'react'
import operatorContext from '../../../context/operator/operatorContext'

const OperatorAcceptedJobItem = ({ acceptedJob }) => {

    const OperatorContext = useContext(operatorContext);


    const { jobStarted, jobCompleted } = OperatorContext;

    const { id ,farm, farmer_equipment_request, status } = acceptedJob;

    const { farm_name, address } = farm;

    const { start_time, end_time } = farmer_equipment_request;

    //Accept new job
    const onStartJob = new_job_id => {
        jobStarted(new_job_id)
    }

    //Decline new job
    const onCompleteJob = new_job_id => {
        jobCompleted(new_job_id)
    }

    return (
        <Fragment>
        
        <td>{farm_name}</td>
        <td>{address}</td>
        <td>{start_time}</td>
        <td>{end_time}</td>
        <td>{status === 0 ? "AVAILABLE" : status === 1 ? "JOB STARTED" : "REJECTED"}</td>
        <td className="button-container">
            <button type="button" onClick={() => onStartJob(id)}
                    className="btn button_style btn-inverse-primary mr-3 waves-effect waves-light">START JOB
            </button>
        </td>
        <td>
            <button type="button" onClick={() => onCompleteJob(id)}
                    className="btn button_style btn-inverse-success waves-effect waves-light">JOB COMPLETED
            </button>
        </td>


    </Fragment>
    )
}

export default OperatorAcceptedJobItem
